import React, { useState } from 'react'
import login_bg from '../assets/images/png/login_bg.png'
import medal from '../assets/images/png/Medal.png'
import original from '../assets/images/png/Original.png'
import packageicon from '../assets/images/png/Package.png'
import packageClock from '../assets/images/png/packageClock.png'
import logo from '../assets/images/png/signInLogo.png'
import { useSelector } from 'react-redux'
import { createUser } from '../services/UserRegister'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'

const VendorJoinForm = () => {
  const selector = useSelector(state => state.userNumber)
  const [name, setName] = useState('')
  const [mobile, setMobile] = useState('')
  const [role, setRole] = useState('vendor')
  const [email, setEmail] = useState('')
  const [city, setCity] = useState('')
  const [password, setPassword] = useState('')
  const [termsAccepted, setTermsAccepted] = useState(false)
  const navigate = useNavigate()

  const userRegistration = async e => {
    e.preventDefault()

    if (!name || !email || !city || !password || !mobile) {
      toast.error('Please fill in all the fields')
      return
    }

    if (!termsAccepted) {
      toast.error('Accept the terms and conditions')
      return
    }

    const vendorLead = {
      name,
      mobile,
      role, // always "vendor"
      email,
      password,
      city,
      adminVerify: false
    }

    try {
      const response = await createUser(vendorLead) // backend should save as pending lead
      console.log(response)
      if (response.status === 'success') {
        toast.success(
          'Your request has been submitted! You will be notified once your account is approved by admin.'
        )
        // optionally, reset form
        setName('')
        setEmail('')
        setCity('')
        setPassword('')
        setMobile('')
        setTermsAccepted(false)
      } else {
        toast.error(response.message || 'Something went wrong.')
      }
    } catch (error) {
      console.error('Error occurred while submitting vendor lead:', error)
      toast.error('Failed to submit your request. Please try again.')
    }
  }

  return (
    <div className='vh-100 bg_clr_light_green d-flex flex-column justify-content-center'>
      <ToastContainer />
      <div className='row p-0 m-0'>
        <div className='col-md-7 overflow-hidden p-0 m-0 d-none d-md-block'>
          <div className='position-relative login-page-img p-0'>
            <img
              className='w-100 object-fit-cover object-position-left'
              src={login_bg}
              height='100%'
            />

            <div className='position-absolute start-50 top-50  p-0 translate-middle w-100 '>
              <div className='d-flex align-items-center flex-column gap-md-3 gap-1'>
                <h2 className='text-center clr_white ff_heebo fs_7xl'>
                  Why Choose Farmer’s City?
                </h2>
                <h3 className='text-center clr_white ff_heebo fs_xl'>
                  Biggest Online Marketplace for Farmers in the World.
                </h3>
              </div>
              <div className='row gap-3 justify-content-center mt-md-4 mt-2'>
                <div className='col-sm-2 col-md-4 col-lg-2 col-4 custom_icon_box'>
                  <div className='w-60 custom_icon_img'>
                    <img src={medal} width='100%' height='100%' />
                  </div>
                  <div className='fs_2xsm custom_icon_text'>Quality</div>
                </div>
                <div className='col-sm-2 col-md-4 col-lg-2 col-4 custom_icon_box'>
                  <div className='w-60 custom_icon_img'>
                    <img src={packageClock} width='100%' height='100%' />
                  </div>
                  <div className='fs_2xsm custom_icon_text'>On Time</div>
                </div>
                <div className='col-sm-2 col-md-4 col-lg-2 col-4 custom_icon_box'>
                  <div className='w-60 custom_icon_img'>
                    <img src={original} width='100%' height='100%' />
                  </div>
                  <div className='fs_2xsm custom_icon_text'>
                    Original Brands
                  </div>
                </div>
                <div className='col-sm-2 col-md-4 col-lg-2 col-4 custom_icon_box'>
                  <div className='w-60 custom_icon_img'>
                    <img src={packageicon} width='100%' height='100%' />
                  </div>
                  <div className='fs_2xsm custom_icon_text'>Free Delievery</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-5 px-2 py-5 bg_clr_light_green vh-100 overflow-auto d-flex justify-content-center'>
          <div className='col-md-11 col-lg-10 col-xl-9 d-flex flex-column gap-md-2 gap-1 justify-content-center'>
            <div className='d-flex flex-column  gap_2'>
              <div className='d-flex justify-content-center align-items-center flex-column gap-2'>
                <div className='text-center'>
                  <img className='w-50' src={logo} />
                </div>
                <h2 className='ff_roboto fw-700'>Farmer’s City</h2>
              </div>
              <div className='d-flex text-center flex-column align-items-center gap-md-3 gap-2'>
                <h2 className='ff_heebo fw-700'>Register As a vendor</h2>
                <p className='ff_heebo clr_dark_grey_2 fw-400 fs-xsm'>
                  Setup a new account
                </p>
              </div>
            </div>
            <div className='w-100'>
              <form
                className='d-flex flex-column gap_2'
                onSubmit={userRegistration}
              >
                <input
                  type='text'
                  className='w-100 py-2 px-3 custom_input'
                  placeholder='Name'
                  value={name}
                  onChange={e => {
                    setName(e.target.value)
                  }}
                />
                <input
                  type='email'
                  className='w-100 py-2 px-3 custom_input'
                  placeholder='Email'
                  value={email}
                  onChange={e => {
                    setEmail(e.target.value)
                  }}
                />
                <input
                  type='text'
                  className='w-100 py-2 px-3 custom_input'
                  placeholder='Mobile Number'
                  value={mobile}
                  onChange={e => setMobile(e.target.value)}
                />
                <input
                  type='password'
                  className='w-100 py-2 px-3 custom_input'
                  placeholder='Password'
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />

                <input
                  type='text'
                  className='w-100 py-2 px-3 custom_input'
                  placeholder='City'
                  value={city}
                  onChange={e => {
                    setCity(e.target.value)
                  }}
                />
                <div className='d-flex align-items-start gap-2'>
                  <input
                    type='checkbox'
                    className='mt-2'
                    checked={termsAccepted}
                    onChange={e => setTermsAccepted(e.target.checked)}
                  />
                  <p className='m-0'>
                    I agree to the all 
                    <span className='border-green-1 fw-600 clr_dark_green'>
                      Terms & Conditions
                    </span>{' '}
                    of Farmer’s City.
                  </p>
                </div>
                <button
                  style={{ height: '40px', lineHeight: '0' }}
                  type='submit'
                  className='mb-4 bg_dark_green clr_white custom_green_button fs_2xsm ff_heebo'
                >
                  CREATE YOUR ACCOUNT
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VendorJoinForm
